import React, { useState, useRef, useEffect } from "react";
import {
  getBlock,
  getDistrict,
  getFY,
  getGPbyBlock,
  getLegderPageCount,
  getOpeningBalance,
  LegderPRI,
} from "../../api/User";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SearchIcon from "@mui/icons-material/Search";
import logo from "../../images/logo192.png";
import html2canvas from "html2canvas";
import loader from "../../images/ajax-loader.gif";
import { DateRange } from "react-date-range";
import { format } from "date-fns";
import { RangeDatePicker } from "react-google-flight-datepicker";
import "react-google-flight-datepicker/dist/main.css";
import "../../index.css";
import { FiArrowLeftCircle } from "react-icons/fi";
import { FiArrowRightCircle } from "react-icons/fi";

function LedgerBook({ token, userDetail }) {
  const [showTable, setShowTable] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [districtData, setDistrictData] = useState([]);
  const [districtType, setDistrictType] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [blockData, setBlockData] = useState([]);
  const [blockType, setBlockType] = useState("");
  const [blockName, setBlockName] = useState("");
  const [GPData, setGPData] = useState([]);
  const [GPName, setGPName] = useState("");
  const [GPType, setGPType] = useState("");
  const [FYData, setFYData] = useState([]);
  const [fy, setFY] = useState("");
  const [month, setMonth] = useState("");
  const role = userDetail?.role_id;
  const id = userDetail?.user_id;
  const [base64Logo, setBase64Logo] = useState("");
  const [visibleOptions, setVisibleOptions] = useState([]);
  const [temp3, setTemp3] = useState([]);
  const [isReadonly, setIsReadonly] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedValueName, setSelectedValueName] = useState("");
  const [loadingBlock, setLoadingBlock] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ledger, setLedger] = useState([]);
  const [openingBalance, setOpeningBalance] = useState("");
  const [fyType, setFyType] = useState([]);
  const [dateRange, setDateRange] = useState({
    startDate: "",
    endDate: "",
    key: "selection",
  });
  const [showDatePicker, setShowDatePicker] = useState(false);
  const datePickerRef = useRef(null);
  const [minDate, setMinDate] = useState();
  const [maxDate, setMaxDate] = useState();
  const [totalPageCount, setTotalPageCount] = useState("");

  const endDateRef = useRef(null);

  useEffect(() => {
    if (GPData?.length === 1) {
      setGPName(GPData[0].VillageName);
      setGPType(GPData[0].VillageId);
    }
  }, [GPData]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const reloaded = urlParams.get("reloaded");

    if (!reloaded) {
      urlParams.set("reloaded", "true");
      window.history.replaceState(null, "", "?" + urlParams.toString());
      window.location.reload();
    }

    const options = [];
    if (role === 6 || role === 7) {
      options.push("gp");
      setSelectedValue("gp");
      setSelectedValueName("Gram Panchayat");
      setIsReadonly(true);
    } else if (role === 8 || role === 9) {
      options.push("ps");
      setSelectedValue("ps");
      setSelectedValueName("Panchayat Samiti");
      setIsReadonly(true);
    } else if (role === 10 || role === 11) {
      options.push("zp");
      setSelectedValue("zp");
      setSelectedValueName("Zila Parishad");
      setIsReadonly(true);
    } else {
      options.push("sab", "gp", "ps", "zp");
      setSelectedValue("");
      setIsReadonly(false);
    }
    fetchData();
    setVisibleOptions(options);
  }, [role]);

  const fetchData = async () => {
    try {
      const res = await getFY(token);
      setFYData([{ FY: "2024-25" }]);
      // setFYData(res.user);
    } catch (error) {
      console.error("Error fetching FY data:", error);
    }
  };

  const fetchDistrictData = async () => {
    try {
      const res = await getDistrict(
        token,
        userDetail.role_id,
        userDetail.user_id
      );
      setDistrictData(res.data);

      if (
        res.data.length > 0 &&
        (role === 6 ||
          role === 7 ||
          role === 8 ||
          role === 9 ||
          role === 10 ||
          role === 11)
      ) {
        setDistrictType(res.data[0].district_code);
        setDistrictName(res.data[0].district_name);
        fetchBlockData(res.data[0].district_code);
        if (role == 38) {
          setDistrictType("");
        }
        if(res.data.length > 1) {
          setIsReadonly(false)
        }
      } else {
        console.log(res.data);
        setDistrictData(res.data);
      }
    } catch (error) {
      console.error("Error fetching district data:", error);
    }
  };

  const fetchBlockData = async (districtCode) => {
    setLoadingBlock(true);
    const data = {
      role_id: userDetail.role_id,
      id: userDetail.user_id,
      district: districtCode,
    };

    try {
      const res = await getBlock(token, data);
      setBlockData(res.user);

      if (res.user.length == 1 && [6, 7, 8, 9, 10, 11].includes(role)) {
        setBlockType(res.user[0].block_code);
        setBlockName(res.user[0].block_name);
        setIsReadonly(true);

        fetchVillageData(res.user[0].block_code, data.district);
      }
    } catch (error) {
      console.error("Error fetching block data:", error);
    }
  };

  const fetchVillageData = async (blockcode, district_code) => {
    const data1 = {
      role_id: userDetail.role_id,
      id: userDetail.user_id,
      district_code: district_code,
      block_code: blockcode,
    };

    try {
      await getGPbyBlock(token, data1)
        .then((res) => {
          setGPData(res.data);
          console.log("helllllllooooo--->", res.data[0]);
          if (res.data.length <= 1) {
            setGPType(res.data[0].VillageId);
            console.log(res.data[0].VillageId);
          }
          setIsReadonly(true);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching block data:", error);
    }
  };

  const handleEntityChange = async (e) => {
    const newValue = e?.target?.value || selectedValue;
    setSelectedValue(newValue);
    await fetchDistrictData();
  };

  useEffect(() => {
    if (selectedValue) {
      handleEntityChange();
    }
  }, [selectedValue]);

  const handleDistrictChange = async (e) => {
    setDistrictType(e.target.value);
    setDistrictName(e.target.options[e.target.selectedIndex].text);
    const data = {
      role_id: userDetail.role_id,
      id: userDetail.user_id,
      district: e.target.value,
    };

    try {
      await getBlock(token, data)
        .then((res) => {
          setBlockData(res.user);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handleBlockChange = async (e) => {
    setBlockType(e.target.value);
    setBlockName(e.target.options[e.target.selectedIndex].text);

    const data = {
      role_id: userDetail.role_id,
      id: userDetail.user_id,
      district_code: districtType,
      block_code: e.target.value,
    };

    try {
      await getGPbyBlock(token, data)
        .then((res) => {
          setGPData(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleGPChange = async (e) => {
    const { value } = e.target;
    const gp = value.split("+");
    setGPName(gp[1]);
    setGPType(gp[0]);
    const data = {
      role_id: role,
      id: id,
      block_code: blockType,
      VillageId: gp[0],
    };
    await fetchData();
    if (endDateRef.current) {
      endDateRef.current.value = "";
    }
  };

  const handleOpeningBalance = async () => {
    const data = {
      role: userDetail.role_id,
      fy: "2024-25",
      quarter: "Q2",
      district: districtType,
      block: blockType,
      village: GPType,
    };
    try {
      await getOpeningBalance(token, data)
        .then((res) => {
          setOpeningBalance(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleMonthChange = (event) => {
    setLoading(true);
    setMonth(event.target.value);
    setTimeout(() => {
      handlePRILedger();
      handleOpeningBalance();
      setLoading(false);
    }, 2000);
  };

  const handleSearch = (event) => {
    event.preventDefault();
    setShowTable(true);
  };

  const handlePRILedger = async (max) => {
    console.log(
      "role:",
      userDetail.role_id,
      "district:",
      districtType,
      "block:",
      blockType,
      "village:",
      GPType,
      "start_date:",
      minDate,
      "end_date:",
      max || maxDate,
      "page:"
    );

    const data = {
      role: userDetail.role_id,
      district: districtType,
      block: blockType,
      village: GPType,
      start_date: minDate,
      end_date: max || maxDate,
      page: pageVal,
    };

    try {
      await LegderPRI(token, data)
        .then((res) => {
          setLedger(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const loadImage = async () => {
      const response = await fetch(logo);
      const blob = await response.blob();
      const reader = new FileReader();
      reader.onloadend = () => setBase64Logo(reader.result);
      reader.readAsDataURL(blob);
    };
    loadImage();
  }, []);

  const exportToPDF = () => {
    const table = document.getElementById("accountTable");

    if (!table) {
      toast.error("Table not found.");
      return;
    }

    const tbody = table.querySelector("tbody");
    if (!tbody || tbody.children.length === 1) {
      toast.error("The table is empty.");
      return;
    }
    html2canvas(table).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(base64Logo, "PNG", 7, 4, 20, 20);

      pdf.setFontSize(16);
      pdf.text(105, 17, "Ledger Book", null, null, "center");
      pdf.addImage(imgData, "PNG", 8, 35, 194, 0);

      pdf.save("LedgerBook.pdf");
      toast.success("Pdf file has been generated successfully.");
    });
  };

  const exportToExcel = () => {
    const table = document.getElementById("accountTable");

    if (!table) {
      toast.error("Table not found.");
      return;
    }

    const tbody = table.querySelector("tbody");
    if (!tbody || tbody.children.length === 1) {
      toast.error("The table is empty.");
      return;
    }

    try {
      const wb = XLSX.utils.table_to_book(table, { sheet: "Sheet1" });
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], { type: "application/octet-stream" });
      saveAs(blob, "LedgerBook.xlsx");

      toast.success("Excel file has been generated successfully.");
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      toast.error("An error occurred while exporting to Excel.");
    }
  };

  useEffect(() => {
    const getCurrentFinancialYear = () => {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1;

      let startYear, endYear;
      if (currentMonth >= 5) {
        startYear = currentYear;
        endYear = currentYear + 1;
      } else {
        startYear = currentYear - 1;
        endYear = currentYear;
      }

      const endYearShort = endYear.toString().slice(-2);
      return `${startYear}-${endYearShort}`;
    };

    const fyYear = getCurrentFinancialYear();
    setFyType(fyYear);
    setFY(fyYear);
  }, []);

  const onDateChange = (startDate, endDate) => {
    if (
      startDate instanceof Date &&
      !isNaN(startDate) &&
      endDate instanceof Date &&
      !isNaN(endDate)
    ) {
      const formattedStartDate = format(startDate, "yyyy-MM-dd");
      const formattedEndDate = format(endDate, "yyyy-MM-dd");

      console.log("start: ", formattedStartDate);
      console.log("end: ", formattedEndDate);
      if (formattedEndDate != "null") {
        setLoading(true);
        setTimeout(() => {
          handlePRILedger();
          handleOpeningBalance();
          setLoading(false);
        }, 2000);
      }
      setDateRange((old) => ({
        ...old,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      }));
    } else {
      console.error("Invalid startDate or endDate");
    }
  };
  const today = new Date().toISOString().split("T")[0];

  const handleStartDate = (e) => {
    setMinDate(e.target.value);
  };

  const handleEndDate = (e) => {
    setMaxDate(e.target.value);
    setLoading(true);
    const data = {
      role: userDetail.role_id,
      district: districtType,
      block: blockType,
      village: GPType,
      start_date: minDate,
      end_date: e.target.value,
    };
    getPageCount(data);
    setTimeout(() => {
      handlePRILedger(e.target.value);
      handleOpeningBalance();
      setLoading(false);
    }, 2000);
  };
  const getPageCount = (data) => {
    getLegderPageCount(token, data).then((res) => {
      setTotalPageCount(res.data);
    });
  };

  const [pageVal, setPageVal] = useState(1);
  // const totalPage = 10;

  const goToPreviousPage = () => {
    if (pageVal > 1) {
      setPageVal(pageVal - 1);
      const newPage = pageVal - 1;
      getAllPRILedgerData(newPage);
    }
  };

  const goToNextPage = () => {
    if (pageVal < totalPageCount) {
      setPageVal(pageVal + 1);
      const newPage = pageVal + 1;
      getAllPRILedgerData(newPage);
    }
  };

  const getAllPRILedgerData = async (newPage) => {
    const data = {
      role: userDetail.role_id,
      district: districtType,
      block: blockType,
      village: GPType,
      start_date: minDate,
      end_date: maxDate,
      page: newPage,
    };

    try {
      await LegderPRI(token, data)
        .then((res) => {
          setLedger(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div>
      <div id="loading-coupon" style={{ display: loading ? "block" : "none" }}>
        <img id="loading-image" src={loader} alt="Loading..." />
      </div>
      <div className="container-fluid col px-2 px-md-4">
        <div className="my-5 col-12 d-flex justify-content-between align-items-center">
          <h5>
            <strong>Ledger Book</strong>
          </h5>
        </div>
        <form className="filter" id="myform" onSubmit={handleSearch}>
          <div className="row mb-4">
            <div className="col-4">
              <label htmlFor="type" className="form-label">
                Entity {<span style={{ color: "red" }}>*</span>}{" "}
              </label>
              {role == 6 || role == 7 || role == 8 ? (
                <input
                  name="type"
                  id="type"
                  className="form-control"
                  value={selectedValueName}
                  onChange={handleEntityChange}
                  disabled={isReadonly}
                  required
                />
              ) : (
                <select
                  name="type"
                  id="type"
                  className="type form-select"
                  value={selectedValue}
                  onChange={handleEntityChange}
                  disabled={isReadonly}
                >
                  <option value="" disabled>
                    Select Type
                  </option>
                  {visibleOptions.includes("sab") && (
                    <option value="sab">All</option>
                  )}
                  {visibleOptions.includes("gp") && (
                    <option value="gp">Gram Panchayat</option>
                  )}
                  {visibleOptions.includes("ps") && (
                    <option value="ps">Panchayat Samiti</option>
                  )}
                  {visibleOptions.includes("zp") && (
                    <option value="zp">Zila Parishad</option>
                  )}
                  {visibleOptions.includes("zp") && (
                    <option value="zp">District</option>
                  )}
                </select>
              )}
            </div>
          </div>
          <div
            className="row d-flex "
            style={{ flexWrap: "nowrap", overflowX: "auto" }}
          >
            <div className style={{ flex: "1 1 45%", margin: "0 0.-3%" }}>
              <label className="form-label">
                District {<span style={{ color: "red" }}>*</span>}
              </label>
              {districtData.length == 1 ? (
                <input
                  name="district"
                  className="form-control"
                  value={districtName}
                  onChange={handleDistrictChange}
                  disabled={isReadonly}
                  required
                />
              ) : (
                <select
                  name="district"
                  className="common-input form-select"
                  value={districtType}
                  onChange={handleDistrictChange}
                 // disabled={isReadonly}
                  required
                >
                  <option value="" disabled selected>
                    Select District
                  </option>
                  {/* {(role === 1 ||
                    role === 2 ||
                    role === 3 ||
                    role === 4 ||
                    role === 19 ||
                    role === 20 ||
                    role === 22||role==38) && <option value="">All</option>} */}

                  
{districtData
  .filter((district, index, self) => 
    index === self.findIndex(d => d.district_code === district.district_code)
  )
  .map((district, index) => (
    <option key={index} value={district.district_code}>
      {district.district_name}
    </option>
  ))}
                </select>
              )}
            </div>
            {(role == 6 || role == 7 || role == 8 || role == 9) && (
              <div className style={{ flex: "1 1 45%", margin: "0 0.-3%" }}>
                <label className="form-label" style={{ fontSize: "17px" }}>
                  Block {<span style={{ color: "red" }}>*</span>}
                </label>
                {blockData?.length == 1 ? (
                  <input
                    name="block"
                    className="form-control"
                    type="text"
                    value={blockData[0]?.block_name}
                    disabled={isReadonly}
                  />
                ) : (
                  <select
                    name="block"
                    className="common-input form-select"
                    value={blockType}
                    onChange={handleBlockChange}
                    required
                  >
                    <option value="" disabled selected>
                      {" "}
                      Select Block
                    </option>

                    {blockData?.map((block, index) => (
                      <option key={index} value={block.block_code}>
                        {block.block_name}
                      </option>
                    ))}
                  </select>
                )}
              </div>
            )}
            {(role == 6 || role == 7) && (
              <div className style={{ flex: "1 1 45%", margin: "0 0.-3%" }}>
                <label className="form-label">
                  Gram Panchayat {<span style={{ color: "red" }}>*</span>}
                </label>
                {GPData?.length == 1 ? (
                  <input
                    name="GP"
                    className="form-control"
                    type="text"
                    value={
                      // GPData && GPData.length > 0 ? GPData[0].VillageName : ""
                      GPName
                    }
                    disabled={isReadonly}
                  />
                ) : (
                  <select
                    name="gp"
                    className="common-input form-select"
                    defaultValue={GPName}
                    onChange={handleGPChange}
                    required
                  >
                    <option value="" disabled>
                      Select Gram Panchayat
                    </option>
                    {GPData?.map((gp, index) => (
                      <option
                        key={index}
                        value={`${gp.VillageId}+${gp.VillageName}`}
                      >
                        {gp.VillageName}
                      </option>
                    ))}
                  </select>
                )}
              </div>
            )}
            <div style={{ flex: "1 1 45%", margin: "0 0.3%" }}>
              <label className="form-label">
                Start Date {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                name="startDate"
                id="startDate"
                type="date"
                className="common-input form-control"
                placeholder="Select start date"
                onChange={handleStartDate}
                max={today}
                required
              />
            </div>

            <div style={{ flex: "1 1 45%", margin: "0 0.3%" }}>
              <label className="form-label">
                End Date {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                name="endDate"
                id="endDate"
                type="date"
                className="common-input form-control"
                placeholder="Select end date"
                onChange={handleEndDate}
                min={minDate}
                max={today}
                ref={endDateRef}
                required
              />
            </div>
          </div>
        </form>
        <div className="row d-flex justify-content-between mt-5">
          <div className="col-md-5">
            <div style={{ width: "96%" }}>
              <div className="input-group ">
                <span className="input-group-text" id="basic-addon1">
                  <SearchIcon />
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Type here to search..."
                  aria-label="Type here to search..."
                  aria-describedby="basic-addon1"
                  id="searchInput"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="col">
            <div className="row" style={{ width: "100%" }}>
              <div style={{ width: "36%" }}>
                <button
                  onClick={exportToPDF}
                  type="button"
                  className="btn"
                  style={{ width: "100%", marginLeft: "-10%" }}
                >
                  Export to PDF
                </button>
              </div>
              <div style={{ width: "35%" }}>
                <button
                  onClick={exportToExcel}
                  type="button"
                  className="btn"
                  style={{ width: "100%", marginLeft: "-10%" }}
                >
                  Export to Excel
                </button>
              </div>
            </div>
          </div>
        </div>

        <div style={{ overflowX: "auto" }} className="my-5">
          <>
            <table
              id="accountTable"
              className="table table-bordered"
              aria-label="simple table"
            >
              <thead>
                <tr style={{ fontSize: "16px", textAlign: "center" }}>
                  <th
                    colSpan="8"
                    align="center"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <div className="justify-content-center">FDMS</div>
                  </th>
                </tr>
                <tr style={{ fontSize: "16px", textAlign: "center" }}>
                  <th
                    colSpan="8"
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#f2f2f2",
                      padding: "10px",
                      fontWeight: "normal",
                    }}
                  >
                    <div className="justify-content-center">
                      Ledger Book of &nbsp;
                      {(role == 6 ||
                        role == 7 ||
                        role == 8 ||
                        role == 9 ||
                        role == 10 ||
                        role == 11) && (
                        <>
                          District &nbsp;
                          <span style={{ fontWeight: "bold" }}>
                            {districtName}
                          </span>
                          &nbsp;
                        </>
                      )}
                      {(role == 6 || role == 7 || role == 8 || role == 9) && (
                        <>
                          Block &nbsp;
                          <span style={{ fontWeight: "bold" }}>
                            {blockName}
                          </span>
                          &nbsp;
                        </>
                      )}
                      {(role == 6 || role == 7) && (
                        <>
                          Gram Panchayat&nbsp;
                          <span style={{ fontWeight: "bold" }}>{GPName}</span>
                          &nbsp;
                        </>
                      )}
                      Financial Year&nbsp;
                      <span style={{ fontWeight: "bold" }}>{fy}</span>
                    </div>
                  </th>
                </tr>
                <tr style={{ fontSize: "16px", textAlign: "right" }}>
                  <th
                    colSpan="8"
                    align="center"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {/* <div className="justify-content-center">Scheme: <p>{selectedValueName}</p></div> */}
                    <div className="justify-content-center">
                      Opening Balance: ₹{openingBalance}
                    </div>
                  </th>
                </tr>
                <tr style={{ fontSize: "16px" }}>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "2%",
                    }}
                  >
                    Sr.No.
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "10%",
                    }}
                  >
                    Date
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "34%",
                    }}
                  >
                    Particulars
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "12%",
                    }}
                  >
                    UTR
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "12%",
                    }}
                  >
                    To
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "10%",
                    }}
                  >
                    Credit Amount
                  </th>
                  {/* <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "10%",
                    }}
                  >
                   Remove
                  </th> */}
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "10%",
                    }}
                  >
                    Debit Balance
                  </th>
                </tr>
              </thead>
              <tbody>
                {!ledger || ledger.length == 0 ? (
                  <tr style={{ fontSize: "16px", color: "grey" }}>
                    <td colSpan="8" style={{ textAlign: "center" }}>
                      No data available
                    </td>
                  </tr>
                ) : (
                  <>
                    {ledger.map((row, index) => (
                      <>
                        <tr key={index}>
                          <td rowSpan={3}>{index + 1}</td>
                          <td rowSpan={3}>{row.date?.split("T")[0]}</td>
                        </tr>
                        <tr>
                          <td title={row.particular}>{`${
                            row.sanction_id
                          }-${row.particular?.slice(0, 20)}...`}</td>
                          <td className="text-center">
                            {row.utr == 0 || row.utr == "" || row.utr == null
                              ? "-"
                              : row.utr}
                          </td>
                          <td
                            title={`${row.vendor_name}`}
                          >{`${row.vendor_code}`}</td>
                          <td
                            style={{
                              color: row.is_credit == 1 ? "red" : "green",
                              textAlign: "center",
                            }}
                          >
                            {row.payable_amount
                              ? (row.is_credit == 1 ? "- " : "") +
                                row.payable_amount
                              : "-"}
                          </td>

                          {/* <td
                            style={{
                              color: "red",
                              textAlign: "center",
                            }}
                          >
                            
                          </td> */}
                          <td
                            style={{
                              textAlign: "center",
                            }}
                          >
                            ₹{" "}
                            {row.is_debit == 1
                              ? parseInt(row.balance) + parseInt(row.deduction)
                              : parseInt(row.balance) -
                                parseInt(row.deduction)}{" "}
                            Cr
                          </td>
                        </tr>
                        <tr>
                          <td>Taxes</td>
                          <td></td>
                          <td>{row.debitAmount}</td>
                          <td
                            style={{
                              color: "green",
                              textAlign: "center",
                            }}
                          >
                            {row.deduction}
                          </td>
                          {/* <td
                            style={{
                              color: "red",
                              textAlign: "center",
                            }}
                          >
                            {row.is_debit == 1 ? row.deduction : "-"}
                          </td> */}
                          <td
                            style={{
                              textAlign: "center",
                            }}
                          >
                            ₹ {row.balance} Cr
                          </td>
                        </tr>
                      </>
                    ))}
                  </>
                )}
              </tbody>
            </table>
            <div className="d-flex justify-content-end">
              <div className="px-5 pb-4 d-flex">
                <div
                  onClick={goToPreviousPage}
                  disabled={pageVal === 1}
                  className={` flex ${
                    pageVal === 1 ? "bg-gray-200 " : "bg-blue-500 text-blue"
                  }`}
                  style={{ cursor: pageVal === 1 ? "not-allowed" : "pointer" }}
                >
                  <FiArrowLeftCircle size={"2rem"} />
                </div>

                {pageVal > 1 && (
                  <span
                    onClick={() => setPageVal(pageVal - 1)}
                    className="cursor-pointer px-3 py-1 rounded-md bg-gray-100"
                    style={{ fontSize: "13px" }}
                  >
                    {pageVal - 1}
                  </span>
                )}

                <span
                  className="px-3 py-0 rounded-md bg-blue-500 font-bold"
                  style={{ fontSize: "18px" }}
                >
                  {pageVal}
                </span>

                {pageVal < totalPageCount && (
                  <span
                    onClick={() => setPageVal(pageVal + 1)}
                    className="cursor-pointer px-3 py-1 rounded-md bg-gray-100"
                  >
                    {pageVal + 1}
                  </span>
                )}

                <div
                  onClick={goToNextPage}
                  disabled={pageVal === totalPageCount}
                  className={`${
                    pageVal === totalPageCount
                      ? "bg-gray-200"
                      : "bg-blue-500 text-gray"
                  }`}
                  style={{
                    cursor:
                      pageVal === totalPageCount ? "not-allowed" : "pointer",
                  }}
                >
                  <FiArrowRightCircle size={"2rem"} />{" "}
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}

export default LedgerBook;
